import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

const headingHighlight = (heading) => {

    if (!heading.classList.contains('js-heading-highlight')) {
        return;
    }

    const highlight = heading.dataset.highlight;
    const lines = heading.querySelectorAll('.js-heading-line');

    if (lines.length == 0) {
        return;
    }

    const lastLine = lines[lines.length - 1];
    const firstLine = lines[0];

    const lastLineClasses = heading.dataset.lastClasses ? heading.dataset.lastClasses.split(',') : [];

    const classes = [
        'pb-0.5',
        'bg-gradient-to-r',
        'from-blue-900',
        'to-green-900',
        'bg-clip-text',
        'text-transparent',
    ];

    if (highlight === 'first') {
        firstLine.classList.add(...classes);
    }

    if (highlight === 'last') {
        lastLine.classList.add(...classes);
        lastLine.classList.add(...lastLineClasses);
    }

}

const headingModule = () => {

    const headings = document.querySelectorAll('.js-heading');

    headings.forEach(heading => {

        const splitText = new SplitText(heading, {
            type: "lines",
            mask: "lines",
            linesClass: 'w-full pb-3 -mb-3 js-heading-line',
            onSplit: () => headingHighlight(heading),
        });

        const lines = splitText.lines;

        gsap.set(heading, {
            opacity: 1,
        });

        ScrollTrigger.matchMedia({
            "(pointer: fine)": () => {

                gsap.set(lines, {
                    yPercent: 120,
                });

                lines.forEach((line, index) => {

                    gsap.to(line, {
                        duration: 1,
                        yPercent: 0,
                        ease: 'power4.inOut',
                        delay: index * 0.04,
                        scrollTrigger: {
                            trigger: heading,
                            start: 'top 100%',
                            end: 'bottom bottom',
                        },

                    });

                });

            },
            "(pointer: coarse)": () => {
                const tl = gsap.timeline();

                tl.to(lines, {
                    yPercent: 0,
                });


                splitText.revert();
            }
        });

    });

    const headingsNotAnimating = document.querySelectorAll('.js-heading-highlight:not(.js-heading)');

    headingsNotAnimating.forEach(heading => {

        const splitText = new SplitText(heading, {
            type: "lines",
            mask: "lines",
            linesClass: 'w-full pb-3 -mb-3 js-heading-line',
            onSplit: () => headingHighlight(heading),
        });

        headingHighlight(heading);

    });

}

export { headingModule };